interface MobilePreviewWrapperProps {
    children: React.ReactNode;
    mobileNode: React.ReactNode;
}

/**
 * Wrap the children and mobileNode in a flex container to align them side by side
 * The default children will be on the left and will take up the full available width while maintaining default html styling
 * The mobileNode will be on the right and will take up a fixed width of 460px
 *
 * On smaller screens, the item will be stacked vertically with the mobileNode on the bottom
 * The mobileNode will be scaled down to fit the screen size
 */

const MobilePreviewWrapper: React.FC<MobilePreviewWrapperProps> = ({ children, mobileNode }) => {
    return (
        <div className='flex flex-col xl:flex-row'>
            <div className='w-full'>
                {children}
            </div>
            <div className='-m-32 sm:m-0 min-w-0 xl:min-w-[460px] scale-75 sm:scale-100 overflow-hidden flex justify-center xl:justify-end mb-0 sm:mb-10'>
                {mobileNode}
            </div>
        </div>
    );
};

export default MobilePreviewWrapper;
